import { gql, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSubmitOperation, {
  getMutationFunction,
  handleFormSubmission,
  usePrepareGraphQLVariables,
} from "../../../../CommonFunction/CustomUseFormSubmission";
import { ClearSpecificForm } from "../../../../Store/FormDataReducer/FormFieldFunctions";
import {
  CreateCustomerAccount,
  DELETE_Account_MUTATION,
  EDIT_CustomerAccount,
  GetAccountDataByID,
  GetAccountRefrencesByID,
  GetCustomerAccountDataByID,
  GrtPreferenceByFormKey,
  LOCK_ACCOUNT,
  MERGE_ACCOUNT,
  NewReferencesOfAccount,
} from "../../../../Utils/AllPagesQuriesAndMutations";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { checkFormErrors } from "../../../custom_hooks/useCheckFormError";
import useConcatenatedString from "../../../custom_hooks/useConcatenatedString";
import useFetchFormFields from "../../../custom_hooks/useFetchFormFields";
import { Confirm } from "../../Confirmation/Confirm";
import { handleFormReset, updateValueForm } from "../../FormInputSectionComponent/formUtils";
import { useModalContext } from "../../Reactportal/ModalContext";
import { ErrorToast } from "../../ToastComponent/RectHotToast";
import ".././FormComponent.scss";
import VendorRemarks from "../AddVendorAccount/AddVendorAccountSection/Remarks";
import ViewVendorFiles from "../AddVendorAccount/ViewFiles";
import { controlData, CustomerRemarksData, DefaultConfiguration } from "./AddCustomerAccount.config";
import "./AddCustomerAccount.scss";
import AddCustomerAccountSection from "./AddCustomerAccountSection/AddCustomerAccountSection";
import { FormConfiguration } from "../../FormConfiguration/FormConfiguration";
import { IoSettingsOutline } from "react-icons/io5";
import extractCustomFields from "../../../CommonFunction/extractCustomFields";
import processFormDataWithCustomFields from "../../../CommonFunction/processFormDataWithCustomFields";
import { ReferenceModal } from "../ReferenceSection/ReferenceModal";
import Button from "../../Button/Button";
import { AmountDetails, initialRef, TransactionTypeDetails } from "../ReferenceSection/Reference.config";
import { convertToISO, IsoToDateWithoutTime } from "../../../../CommonFunction/IsoDateTime";
import useIsDisabled from "../../../custom_hooks/useIsDisabled";
import { AccountGroupData } from "../AddAccountGroup/AddAccountGroup.config";
import SelectDataFromTable from "../../SeletFromDatable/SelectDataFromTable";
import { ConvertDateValues } from "../../../custom_hooks/ChangeDateValues";
import { extractIds } from "../../SeletFromDatable/convartdataintoIds";
import { GetTodaysDateINdmy } from "../../../../CommonFunction/GetTodaysDate";

export const AccoutDetails = gql`
  query AccountsByAccountType($accountType: String = "Customer Account") {
    AccountsByAccountType(Account_Type: $accountType) {
      Name
      Account_Group_Name
      Unique_Id
      Business_Mobile_Number
      TBB_Rights
      _id
    }
  }
`;

const AddCustormerAccount = ({
  show,
  TypeOfPortal,
  submitType,
  ParentPortalCloseFunction,
  setShow,
  ReferenceFieldName = [],
  ReferFormKey = "",
}) => {
  const Form_Key = "Customer_Account";
  // console.log(show);
  const modifiedTypeOfPortal = useConcatenatedString(TypeOfPortal, "Customer Account");
  const ReferenceData = useSelector((store) => store.TableDataReducer.tableData);
  const { pushModal, popModal } = useModalContext();
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata =
    fielddataRedux?.Customer_Account?.Selected_Row ||
    fielddataRedux?.Account_Vouchers?.Selected_Row ||
    fielddataRedux?.Transaction_Checks?.Selected_Row;
  const [toggle, settoggle] = useState(show ? true : false);
  const [isFirstLoad, setFirstLoad] = useState(false);
  const [allFieldsData, setAllFieldsData] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [FormData, setFormdata] = useState({});
  const [RefRows, setRefRows] = useState({ 1: {} });
  const [showRemarkModal, setShowRemarkModal] = useState(false);
  const [RemarkFields, SetRemarkFields] = useState(CustomerRemarksData["Is_Verified"]);
  const [ShowInfoModal, setShowInfoModal] = useState(false);
  const [Remark, setRemark] = useState({
    Verified_Remark: "",
  });
  const formRef = useRef({});
  const dispatch = useDispatch();
  const FormDataFromRedux = useSelector((store) => store?.FormDataReducer);
  const [loadingState, setLoadingState] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [openSetting, setOpenSetting] = useState(false);
  const [storeCustomFields, setStoreCustomFields] = useState([]);
  const [openRef, setOpenRef] = useState(false);
  const [AccountsData, setAcountsData] = useState([]);
  const [selectedAccounts, setSelectedAccounts] = useState([]);
  // console.log(selectedAccounts, "selectedAccountsselectedAccounts")
  const [showAccounsts, setShowAccounts] = useState(false);

  const selectedIds = useSelector(
    (store) => store?.UniqueTableReducer?.[`Select_Table_Data_${Form_Key}`]?.Selected_Rows
  );

  const [initialData, setInitialData] = useState({});
  const { isDisabled } = useIsDisabled({ TypeOfPortal, initial: initialData, current: FormData });

  const [MergingData, { loading: MergeEmtAccountLoading }] = useMutation(MERGE_ACCOUNT, {
    fetchPolicy: "network-only",
  });
  const {
    loading: getFormFieldsLoading,
    data: inputFields,
    getFormSectionAndFields,
  } = useFetchFormFields({ Form_Key: TypeOfPortal == "Merge" ? "Customer_Merge" : "Customer_Account" });
  const [GetDefaultAccountGroup] = useLazyQuery(AccountGroupData);

  const { data: AccountQiery } = useQuery(AccoutDetails, {
    fetchPolicy: "network-only",
    onCompleted: (res) => {
      if (res?.AccountsByAccountType?.length) {
        setAcountsData(ConvertDateValues(res?.AccountsByAccountType));
      }
    },
  });
  const [CreatingData, { loading: createCustomerAccountLoading }] = useMutation(CreateCustomerAccount);

  const [GetDataByID, { loading: getByIDLoader }] = useLazyQuery(GetCustomerAccountDataByID, {
    fetchPolicy: "network-only",
  });
  const [GetRefByID] = useLazyQuery(GetAccountRefrencesByID, {
    fetchPolicy: "network-only",
  });

  const [DeletingData, { loading: deleteCustomerAccountLoading }] = useMutation(DELETE_Account_MUTATION);

  const [EditingData, { loading: editCustomerAccountLoading }] = useMutation(EDIT_CustomerAccount);

  const [lockTheEntry, { loading: lockCustomerAccountLoading }] = useMutation(LOCK_ACCOUNT);

  const [getDataByKey, { loading: userPreferenceLoading }] = useLazyQuery(GrtPreferenceByFormKey, {
    variables: {
      Form_Key: Form_Key,
    },
    fetchPolicy: "network-only",
  });

  const CustomerLoadingState =
    getFormFieldsLoading ||
    createCustomerAccountLoading ||
    deleteCustomerAccountLoading ||
    editCustomerAccountLoading ||
    lockCustomerAccountLoading ||
    getByIDLoader ||
    userPreferenceLoading;

  useEffect(() => {
    if (selectedIds?.length && !showAccounsts) {
      setSelectedAccounts(selectedIds);
    }
  }, [selectedIds, showAccounsts]);
  const OpenReference = () => {
    setOpenRef(true);
  };
  const OpenAccountsModal = () => {
    setShowAccounts(true);
  };
  // Handle errors received from FormInputSectionComponent
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  //to check errors and throw the error submit will not
  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };

  const [disabled, setDisabled] = useState(false);

  const handleDisabled = (data) => {
    setDisabled(data);
  };

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const getDefaultValues = async () => {
    GetDefaultAccountGroup({
      variables: {
        keyword: "Sundary Debitors",
      },
    }).then(({ data }) => {
      // console.log(data)
      let group = data?.searchAccountGroups[0];

      updateValueForm(formRef, {
        Account_Group: group?.Search_Value,
        Balance_Method: true,
        Account_Type: "Customer Account",
        Opening_Balance: 0,
        Credit_Or_Debit: "Db",
      });
      dispatch({
        type: "StoreMasterData",
        payload: {
          formkey: Form_Key,
          data: {
            Account_Group: group,
          },
        },
      });
    });
  };

  useEffect(() => {
    // console.log(TypeOfPortal, "TypeOfPortalTypeOfPortalTypeOfPortalTypeOfPortal");
    if (TypeOfPortal !== "Delete") {
      getFormSectionAndFields().then(() => {
        if (TypeOfPortal !== "Add") {
          let id = fielddata?.__typename === "AccountBalanceSchema" ? fielddata?.Account_Type_Id : fielddata?._id;
          GetDataByID({
            variables: {
              id: id,
            },
          }).then(({ data }) => {
            let accountClone = { ...data?.Account };
            setRemark({
              Verified_Remark: accountClone?.Verified_Remark,
            });
            dispatch({
              type: "StoreMasterData",
              payload: {
                formkey: Form_Key,
                data: {
                  Account_Group: { _id: accountClone?.Account_Groups?._id },
                  Account_Manager: accountClone.Account_ManagerData,
                  Price_List: accountClone.Price_List_Data,
                },
              },
            });
            if (accountClone && accountClone.Account_Groups) {
              accountClone.Account_Group = accountClone.Account_Groups.Account_Group;
            }
            if (accountClone && accountClone.Account_ManagerData) {
              accountClone.Account_Manager = accountClone.Account_ManagerData.Full_Name;
            }
            if (accountClone && accountClone.Price_List_Data) {
              accountClone.Price_List = accountClone.Price_List_Data.Name;
            }
            if (accountClone?.customFieldData && typeof accountClone.customFieldData === "object") {
              Object.entries(accountClone.customFieldData).forEach(([key, value]) => {
                accountClone[key] = value ?? ""; // Assign value or empty string if undefined/null
              });
            }
            setAllFieldsData(accountClone);
            if (accountClone?.consignee?.length) {
              setSelectedAccounts(extractIds(accountClone?.consignee));
            }
            updateValueForm(formRef, accountClone);
          });
          GetRefByID({
            variables: {
              Account_Id: id,
            },
          }).then(({ data }) => {
            if (data?.getAccountRefrencesByID?.length) {
              let updatedTransRef = {};
              data?.getAccountRefrencesByID?.map((el) => {
                let InitialRef = [
                  ...initialRef.slice(0, -1),
                  AmountDetails,
                  TransactionTypeDetails,
                  initialRef[initialRef.length - 1],
                ];
                let singleRef = InitialRef.map((item) => {
                  if (item.name === "Particular") {
                    item = { ...item, NewRef_Id: el["NewRef_Id"] };
                  }
                  if (item.name === "RefDate") {
                    return { ...item, value: IsoToDateWithoutTime(el[item.name]) };
                  }
                  return { ...item, value: el[item.name] };
                });
                updatedTransRef = {
                  ...updatedTransRef,
                  [Math.random() * 10]: singleRef,
                };
              });
              // console.log(updatedTransRef);
              setRefRows({
                [1]: updatedTransRef,
              });
            }
          });
        } else {
          getDefaultValues();
        }
      });
    }
  }, [fielddata]);

  useEffect(() => {
    setSelectedRows(fielddataRedux?.Customer_Account?.Selected_Rows);
  }, [fielddataRedux]);

  useEffect(() => {
    setLoadingState(loadingState);
  }, [loadingState]);

  useEffect(() => {
    if (isFirstLoad) {
      setShowRemarkModal(FormData?.Is_Verified);
      SetRemarkFields(CustomerRemarksData["Is_Verified"]);
    }
  }, [FormData?.Is_Verified]);

  const HanldeChangeonForm = (values) => {
    setFormdata((prev) => {
      const next = { ...prev, ...values };
      if (!isFirstLoad) {
        setInitialData(next);
      }
      return next;
    });
  };

  // This code snippet dynamically manages CRUD (Create, Read, Update, Delete) for Brief Understanding Refer MD Documentation in FormComponents,
  const { executeOperation } = useSubmitOperation();
  const operationType = TypeOfPortal;
  let newFormData = { ...FormData, ...Remark };
  const variables = usePrepareGraphQLVariables(operationType, allFieldsData, newFormData, selectedRows);
  const mutationFunctions = {
    CreatingData,
    EditingData,
    DeletingData,
    lockTheEntry,
    MergingData,
  };

  if (operationType === "Merge") {
    newFormData.existingId = fielddata?._id;
    newFormData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
  }

  formRef.current.OpenReviewModal = (fieldName) => {
    setShowInfoModal(true);
    SetRemarkFields(CustomerRemarksData[fieldName.name] || fieldName);
  };

  useEffect(() => {
    if (inputFields && inputFields?.length > 0) {
      const fields = extractCustomFields(inputFields);
      setStoreCustomFields(fields);
    }
  }, [inputFields]);

  useEffect(() => {
    let total = FormData?.Opening_Balance;
    // console.log(total, isFirstLoad, FormData?.Balance_Method, FormData?.Credit_Or_Debit);
    if (
      total &&
      (FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) &&
      FormData?.Credit_Or_Debit &&
      isFirstLoad
    ) {
      let InitialRef = [
        ...initialRef.slice(0, -1),
        AmountDetails,
        TransactionTypeDetails,
        initialRef[initialRef.length - 1],
      ];

      let singleRef = InitialRef.map((item) => {
        // console.log(item, "itemitem");
        if (item.name === "Particular") {
          return { ...item, value: FormData?.Invoice_No || "" };
        }
        if (item.name === "Type") {
          return { ...item, value: `New Reference` };
        }
        if (item.name === "Amount") {
          return { ...item, value: total };
        }
        if (item.name === "TransactionType") {
          console.log(FormData?.Credit_Or_Debit, FormData);
          return {
            ...item,
            value: FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : "",
          };
        }
        if (item.name === "RefDate") {
          return { ...item, value: GetTodaysDateINdmy() };
        }
        return item;
      });

      let updatedTransRef = {
        [Math.random() * 10]: singleRef,
      };
      console.log(updatedTransRef, "updatedTransRefupdatedTransRef");
      setRefRows({
        [1]: updatedTransRef,
      });
    }
  }, [FormData?.Opening_Balance, FormData?.Credit_Or_Debit, FormData?.Balance_Method]);

  useEffect(() => {
    dispatch({ type: "tableData", payload: RefRows });
  }, [RefRows]);

  const submit = async (closeAction) => {
    let Name = ReferenceFieldName[0]?.name;
    let formData = {};
    if (operationType === "Merge") {
      formData.existingId = fielddata?._id;
      formData.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
      variables.existingId = fielddata?._id;
      variables.newId = FormDataFromRedux?.MasterData?.[Form_Key]?.replace_with?._id;
    } else {
      formData = processFormDataWithCustomFields(newFormData, storeCustomFields);
      formData.Account_Type = formData.Account_Type || "Customer Account";
      formData.KYC_Complete = formData.KYC_Complete || false;
      formData.consignee = extractIds(selectedAccounts);
      formData.Is_Bank_Verified = formData.Is_Bank_Verified || false;
      formData.Is_Gst_Verified = formData.Is_Gst_Verified || false;
      formData.Is_Pan_Verified = formData.Is_Pan_Verified || false;
      formData.Is_Aadhar_Verified = formData.Is_Aadhar_Verified || false;
      formData.Is_Email_Verified = formData.Is_Email_Verified || false;
      formData.Is_Lock = formData.Is_Lock || false;
      formData.Is_Mobile_Number_Verified = formData.Is_Mobile_Number_Verified || false;
      formData.Is_Document_Verified = formData.Is_Document_Verified || false;
      formData.Is_Verified = formData.Is_Verified || false;
      formData.Account_Manager = FormDataFromRedux?.MasterData[Form_Key]?.Account_Manager?._id;
      formData.Account_Group = FormDataFromRedux?.MasterData[Form_Key]?.Account_Group?._id;
      formData.Balance_Method = formData?.Balance_Method ? "Bill By Bill" : "Balance Only";
      formData.Price_List = FormDataFromRedux?.MasterData[Form_Key]?.Price_List?._id;

      delete formData.accountgroups;
    }

    if (operationType !== "Delete") {
      // Ensure Aadhar_Number is treated as a string
      if (formData.Aadhar_Number && typeof formData.Aadhar_Number !== "string") {
        formData.Aadhar_Number = formData.Aadhar_Number?.toString();
      }
      // Apply the replace operation to remove non-numeric characters if Aadhar_Number exists
      if (formData.Aadhar_Number) {
        formData.Aadhar_Number = formData.Aadhar_Number.replace(/[^0-9]/g, "");
      }
    }
    let References = (ReferenceData[1] ? Object.keys(ReferenceData[1]) : []).map((key) => {
      let obj = {};
      let flag = true;
      ReferenceData[1][key].forEach((item) => {
        // if (item?.name === "Unique_Id") {
        //   return;
        // }
        if (item.name === "RefDate" && item.value) {
          obj = {
            ...obj,
            [item.name]: convertToISO(item.value),
          };
        } else if (item?.name === "Particular") {
          if (!item.value) {
            obj = {
              ...obj,
              [item.name]: "",
            };
          }
          obj = {
            ...obj,
            [item.name]: item.value,
          };
          if (item?.NewRef_Id) {
            obj = { ...obj, NewRef_Id: item.NewRef_Id };
          }
        } else if (item) {
          obj = { ...obj, [item.name]: item.value };
        }
      });
      console.log(obj, flag);
      return obj;
    });
    if (FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true) {
      variables.ReferenceInput = References;
    }
    delete formData.accountgroups;
    console.log(formData, variables);
    const mutationFunction = getMutationFunction(operationType, mutationFunctions);
    const executeOperationFunction = () => {
      return executeOperation({
        operationType,
        data: formData,
        selectedRows,
        Mutation: () => mutationFunction({ variables }),
        processDataBeforeSubmit: (data) => data,
        EditRefresh: false,
        PageName: Form_Key,
        OnSuccess: (res) => {
          console.log(ReferenceFieldName, Name, res, "ReferFormKeyReferFormKey");
          dispatch({
            type: "StoreMasterData",
            payload: {
              formkey: ReferFormKey,
              data: {
                [Name]: res?.data?.createAccount || res?.data?.editAccount,
              },
            },
          });
        },
      });
    };
    handleFormSubmission(executeOperationFunction, {
      dispatch,
      Form_Key,
      operationType,
      closeAction,
      closeFormFunction: Closeformfunction,
      resetFormDataFunction: () => {
        handleFormReset(formRef);
        getDefaultValues();
      },
      onSuccess: () => {
        dispatch({ type: "Refetch", payload: true });
      },
      onError: (error) => {
        ErrorToast(error.message);
      },
    });
  };

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    setAllFieldsData({});
    popModal(Form_Key);
    dispatch({ type: "DELETE_UNIQUE_TABLE_KEY", payload: { key: `Select_Table_Data_${Form_Key}` } });
    ClearSpecificForm(dispatch, Form_Key);
    if (setShow) {
      setShow(false);
    }
  };
  const SaveAndCloseForAdd = () => {
    submit("Close");
  };

  const HandleRemarkChange = (e) => {
    setRemark((prev) => {
      return { ...prev, [e.target.name]: e.target.value };
    });
  };

  const HandleSettingClick = () => {
    setOpenSetting(true);
  };

  if (TypeOfPortal === "Lock" || TypeOfPortal === "Unlock" || TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm
          submitType={`Confirm ${TypeOfPortal}`}
          submit={submit}
          settoggle={settoggle}
          toggle={toggle}
          loadingState={CustomerLoadingState}
          message={`Are You Sure You Want to ${TypeOfPortal} this Record?`}
        />
      </>
    );
  }

  const FooterContent = (
    <PortalFooter
      Form_key={Form_Key}
      renderContent={() => (
        <>
          {FormData?.Balance_Method === "Bill By Bill" || FormData?.Balance_Method === true ? (
            <>
              <Button action={() => OpenReference()} name="modalbutton" text="Reference" />
            </>
          ) : (
            <></>
          )}
          {TypeOfPortal !== "Merge" && (
            <Button action={() => OpenAccountsModal()} name="modalbutton" text="Consignee" />
          )}
        </>
      )}
      disabled={isDisabled}
      TypeOfPortal={TypeOfPortal}
      submitform={() => Validate_handleSubmit(submit)}
      submitType={submitType}
      SaveAndClose={
        TypeOfPortal === "Add"
          ? () => {
              Validate_handleSubmit(SaveAndCloseForAdd);
            }
          : () => {
              Validate_handleSubmit(submit);
            }
      }
      handleformclose={() => {
        Closeformfunction();
        settoggle(!toggle);
      }}
      loadingState={CustomerLoadingState}
    />
  );

  return (
    <>
      <div>
        <Reactportal
          FoooterContent={FooterContent}
          Form_Key={Form_Key}
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={modifiedTypeOfPortal}
          TypeOfId={``}
          id={allFieldsData?.Unique_Id}
          AdditionalContent={() => {
            // return (
            //   <span onClick={HandleSettingClick} className="settingIcon">
            //     <IoSettingsOutline className="settingIcon" />
            //   </span>
            // );
          }}
        >
          <div className="CustomerAccountSection">
            {CustomerLoadingState && <div className="loader-line-div" />}
            <div className="formContainer">
              {inputFields && inputFields?.length > 0 ? (
                inputFields.map((e) => (
                  <React.Fragment key={e.id}>
                    <AddCustomerAccountSection
                      inputfields={e.fields}
                      Type={e.name}
                      Data={e}
                      fielddata={allFieldsData}
                      TypeOfPortal={TypeOfPortal}
                      handleDisabled={handleDisabled}
                      controlData={controlData}
                      handleErrorsChange={handleErrorsChange}
                      HanldeChangeonForm={HanldeChangeonForm}
                      ValidationName={e?.ValidationName}
                      formkey={Form_Key}
                      formRef={formRef}
                      setFirstLoad={setFirstLoad}
                      isFirstLoad={isFirstLoad}
                    />
                  </React.Fragment>
                ))
              ) : !getFormFieldsLoading && (inputFields?.message || inputFields?.length === 0) ? (
                <p>No form fields available.</p>
              ) : null}
            </div>
          </div>
        </Reactportal>
      </div>
      {showRemarkModal && (
        <VendorRemarks
          show={showRemarkModal}
          onhandleFormikChange={HandleRemarkChange}
          field={RemarkFields}
          values={Remark}
          setShowModal={() => setShowRemarkModal(false)}
        />
      )}
      {ShowInfoModal && (
        <ViewVendorFiles
          Values={formRef?.current?.Controls?.values}
          show={true}
          TypeOfPortal={TypeOfPortal}
          setShowModal={() => setShowInfoModal(false)}
          accountId={fielddata?._id}
          Remark={Remark}
          Type={
            RemarkFields.name === "Is_Pan_Verified"
              ? "PAN"
              : RemarkFields.name === "Is_Gst_Verified"
              ? "GST"
              : RemarkFields.name === "Is_Aadhar_Verified"
              ? "Aadhaar"
              : RemarkFields.name === "Verified_Remark"
              ? "verified"
              : "Bank"
          }
        />
      )}
      {openSetting && (
        <FormConfiguration
          show={openSetting}
          ParentClosingFunction={setOpenSetting}
          config={DefaultConfiguration}
          HanldeChangeonForm={HanldeChangeonForm}
          formRef={formRef}
          getFormSectionAndFields={getFormSectionAndFields}
          setFirstLoad={setFirstLoad}
          allFieldsData={allFieldsData}
          ToGetDefaultValues={() => {
            getDefaultValues();
          }}
          formKey={Form_Key}
          forFormValues={FormData}
          preference={false}
        />
      )}
      {openRef && (
        <ReferenceModal
          show={openRef}
          setModalToggle={() => setOpenRef(false)}
          transactionId={1}
          Amount={FormData?.Opening_Balance}
          Account_ID={""}
          query={NewReferencesOfAccount}
          Transaction_Type={
            FormData?.Credit_Or_Debit == "Cr" ? "Credit" : FormData?.Credit_Or_Debit == "Db" ? "Debit" : ""
          }
        />
      )}

      {showAccounsts && (
        <SelectDataFromTable
          data={AccountsData}
          selectedRows={selectedAccounts}
          TypeOfPortal={TypeOfPortal}
          toggle={showAccounsts}
          setToggle={setShowAccounts}
          TableKey={Form_Key}
        />
      )}
    </>
  );
  // }
};

export default AddCustormerAccount;
